import React from 'react';
import NavMenuVZY from './NavMenuVZY';

export const VzyLayout = (props) => {

    return (
        <div className="layout-main vzy-container">
            <NavMenuVZY />
            {props.children}
        </div>
    );
}
